import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "new_components/InvestorRelations/InvestorRelations.scss";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";
import axios from "axios";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";
import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
import globeIcon from "../../new_assets/new_images/InvestorRelation/web-svgrepo-com.png";
import mailIcon from "../../new_assets/new_images/InvestorRelation/emailicon.png";
const InvestorRelations = () => {
  return (
    <>
      <ScrollToTopDefault />
      <ProgressCircle />
      <Header />
      <Body />
      <Footer />
    </>
  );
};

const Body = () => {
  return (
    <div>
      <InvestorRelationsBanner />
      <InvestorRelationsSteps />
      <InvestorRelationsFundingTimelines />
      {/* <HomeBottomBanner /> */}
    </div>
  );
};

const InvestorRelationsBanner = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const Preload = () => {
    return (
      <div className="preload preload-container">
        <div className="preload-logo">
          <div className="spinner" />
          <span className="icon icon-villa-fill" />
        </div>
      </div>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.investorRelationBanner);

        if (response.data?.status === "success" && response.data?.data) {
          setData(response.data.data);
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div>
        <Preload />
      </div>
    );
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <section className="flat-section">
      <div className="container">
        <div
          className="row align-items-center justify-content-center wow fadeInUp investorrelationbanner mx-md-5 px-1 px-md-5"
          style={{
            backgroundImage: `url(${Image_Base_URL + data.image})`,
          }}
          data-wow-delay=".2s"
        >
          <div className="col-12 text-center">
            <p className="subtitle text-white body-2 wow fadeInUp">
              {data.title1}{" "}
            </p>
            <h3 className="title text-white">{data.subtitle1}</h3>
          </div>
          <div className="col-12 text-center mt-5">
            <p className="subtitle text-white body-2 wow fadeInUp fs-5 ">
              {data.title2}{" "}
            </p>
            <h4 className="title text-white">{data.subtitle2} </h4>
          </div>
          <div className="col-12 text-center mt-5">
            <h6 className="title text-white">
              {" "}
              <a href={`mailto:${data.bottom_text}`} className="email-link">
                {data.bottom_text}
              </a>
            </h6>
          </div>
        </div>
      </div>
    </section>
  );
};

const InvestorRelationsSteps = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.investorRelationSteps);

        const fetchedData = response.data?.data;
        if (response.data?.status === "success") {
          setData(response.data.data);
        } else {
          setError("No data available");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message || "An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data) return <div>No data available</div>;

  return (
    <section className="flat-section bg-primary-new">
      <div className="container3">
        <div className="flat-img-with-text-v2">
          <div className="content-left tf-image-box">
            <div className="grid-img-group">
              {data.overlay_image_1 && (
                <div className="tf-image-wrap item-1">
                  <div className="img-style hover-img-wrap exp-sub-inv">
                    <img
                      className="lazyload"
                      data-src={`${Image_Base_URL}${data.overlay_image_1}`}
                      src={`${Image_Base_URL}${data.overlay_image_1}`}
                      alt="Expertise Image 1"
                    />
                  </div>
                  {data.overlay_text_1 && (
                    <div className="tag-item ani5">
                      <i className="icon icon-check-circle" />
                      <span>{data.overlay_text_1}</span>
                    </div>
                  )}
                </div>
              )}
              {data.overlay_image_2 && (
                <div className="tf-image-wrap item-2">
                  <div className="img-style hover-img-wrap exp-main-inv">
                    <img
                      className="lazyload"
                      data-src={`${Image_Base_URL}${data.overlay_image_2}`}
                      src={`${Image_Base_URL}${data.overlay_image_2}`}
                      alt="Expertise Image 2"
                    />
                  </div>
                  {data.overlay_text_2 && (
                    <div className="tag-item tag-item-1 ani4">
                      <i className="icon icon-check-circle" />
                      <span>{data.overlay_text_2}</span>
                    </div>
                  )}
                  {data.overlay_text_3 && (
                    <div className="tag-item tag-item-2 ani5">
                      <i className="icon icon-check-circle" />
                      <span>{data.overlay_text_3}</span>
                    </div>
                  )}
                </div>
              )}
              {data.overlay_image_3 && (
                <div className="tf-image-wrap item-3">
                  <div className="img-style hover-img-wrap exp-sub-inv">
                    <img
                      className="lazyload"
                      data-src={`${Image_Base_URL}${data.overlay_image_3}`}
                      src={`${Image_Base_URL}${data.overlay_image_3}`}
                      alt="Expertise Image 3"
                    />
                  </div>
                  {data.overlay_text_4 && (
                    <div className="tag-item ani4">
                      <i className="icon icon-check-circle" />
                      <span>{data.overlay_text_4}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="content-right">
            <div className="box-title wow fadeInUp">
              <h3 className="title mt-4">{data.title}</h3>
              <h4 className="desc">{data.subtitle}</h4>
            </div>
            <div className="box-title wow fadeInUp">
              <h5 className="mt-2">{data.heading_1}</h5>
                    <div
                className="desc text-variant-1 mt-1"
                dangerouslySetInnerHTML={{
                  __html: data.description_1
                    ?.replace(/<p>/gi, '<p class="mt-1">')
                    .replace(/<a /gi, '<a class="email-link text-primary" ') || "",
                }}
              />
            </div>
            <div className="box-title wow fadeInUp">
              <h5 className="mt-4">{data.heading_2}</h5>
              <div
                className="desc text-variant-1 mt-1"
                dangerouslySetInnerHTML={{
                  __html: data.description_2
                    ?.replace(/<p>/gi, '<p class="mt-1">')
                    .replace(/<a /gi, '<a class="email-link text-primary" ') || "",
                }}
              />
            </div>
            <div className="box-title wow fadeInUp">
              <h5 className="mt-4">{data.heading_3}</h5>

                     <div
                className="desc text-variant-1 mt-1"
                dangerouslySetInnerHTML={{
                  __html: data.description_3
                    ?.replace(/<p>/gi, '<p class="mt-1">')
                    .replace(/<a /gi, '<a class="email-link text-primary" ') || "",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const InvestorRelationsFundingTimelines = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isEmailHovered, setIsEmailHovered] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          apiUrls.investorRelationFundingTimeline,
        );
        if (response.data.status === "success") {
          setData(response.data.data);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <section className="flat-section">
      <div className="container">
        <div className="row align-items-center mb-4 wow fadeInUp">
          <div className="col-md-5 mb-5 mb-md-0 pe-md-4">
            <div className="wow fadeInUp mb-3">
              <h5 className="fw-bold">{data.main_heading}</h5>
            </div>
            <div className="timeline-wrapper">
              <div className="row mb-3">
                <div className="col-6">
                  <h6 className="fw-bold mb-0">{data.timeline_heading}</h6>
                </div>
                <div className="col-2"></div>
                <div className="col-4">
                  <h6 className="fw-bold mb-0">{data.steps_heading}</h6>
                </div>
              </div>
              {data?.timeline_items.map((item, index) => (
                <div className="mb-3" key={index}>
                  <div className="row pb-2 align-items-center">
                    <div className="col-6">
                      <p className="mb-0">{item.method}</p>
                    </div>
                    <div className="col-2 text-center">
                      <span className="icon icon-arrow-right2" style={{ color: "#2e7d32" }}></span>
                    </div>
                    <div className="col-4">
                      <p className="mb-0">{item.lead_time}</p>
                    </div>
                  </div>
                  <div className="timeline-row"></div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-7 ps-md-4">
            <div className="row text-center">
              {data.steps.map((step, index) => (
                <div className="col-md-4 mb-3 mb-md-0" key={index}>
                  <div className="rounded-circle bg-primary-new d-inline-flex align-items-center justify-content-center mb-3 p-3">
                    <span className="fw-bold text-success px-4 py-3 fs-2">
                      {step.step_number}
                    </span>
                  </div>

                  <h6 className="fw-bold">{step.step_title}</h6>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="container pt-4">
        <div
          className="tf-grid-layout md-col-3 sm-col-2 wow fadeInUp "
          data-wow-delay=".2s"
        >
          {/* Card 1 & 2 */}
          {data?.cards?.slice(0, 2).map((card, index) => (
            <div
              className="box-service data-card d-flex align-items-start"
              key={index}
            >
              <div className="card-logo-wrapper pb-3">
                <img
                  src={`${Image_Base_URL}${card.logo_image}`}
                  alt={card.card_title}
                  className="investor-card-icon"
                />
              </div>
              <h6 className="fw-bold mb-2 pb-1">{card.card_title}</h6>

              <p className="mb-2">{card.card_description}</p>

              <div className="content">
                <a href={card.button_url} className="tf-btn btn-line">
                  {card.button_text}
                  <span className="icon icon-arrow-right2" />
                </a>
              </div>
            </div>
          ))}

          {/* Card 3 separate Contact Card*/}
          {data && (
            <div className="box-service contact-card data-card d-flex align-items-start">
              <h6 className="fw-bold mb-4 mt-2 text-white pb-2">
                {data.contact_title}
              </h6>

              <p className="mb-2 contact-column pb-4">
                <img src={globeIcon} alt="website" className="contact-icon" />

                <a
                  href="#"
                  title={copied ? "Copied!" : "Click to copy link"}
                  className={copied || isHovered ? "text-primary" : ""}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  onClick={(e) => {
                    e.preventDefault();

                    navigator.clipboard.writeText(data.contact_website_url);

                    setCopied(true);

                    setTimeout(() => {
                      setCopied(false);
                    }, 1500);
                  }}
                >
                  {data.contact_website_label}
                </a>
              </p>

              <p className="contact-column">
                <img src={mailIcon} alt="email" className="contact-icon me-2" />

                <a
                  href={`mailto:${data.contact_email}`}
                  className={isEmailHovered ? "text-primary" : ""}
                  onMouseEnter={() => setIsEmailHovered(true)}
                  onMouseLeave={() => setIsEmailHovered(false)}
                >
                  {data.contact_email}
                </a>
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default InvestorRelations;
